import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AdminDataProvider, useAdminData } from './contexts/AdminDataContext';
import { AdminShell } from './components/admin/AdminShell';
import { PublicSite } from './pages/PublicSite';
import { AdminLogin } from './pages/admin/AdminLogin';
import { Overview } from './pages/admin/Overview';
import { Cases } from './pages/admin/Cases';
import { CaseNew } from './pages/admin/CaseNew';
import { CaseDetail } from './pages/admin/CaseDetail';
import { Customers } from './pages/admin/Customers';
import { CustomerDetail } from './pages/admin/CustomerDetail';
import { Settings } from './pages/admin/Settings';
import { company } from './data/site';
import { applyBrandIcon } from './utils/favicon';
function RequireAdmin({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    loggedIn
  } = useAdminData();
  if (!loggedIn) return <Navigate to="/admin/login" replace data-id="element-0" data-mp="23w4g45bdvc2y" />;
  return <>{children}</>;
}
export function App() {
  useEffect(() => {
    applyBrandIcon(company.logoMark, 'Lykkeværk');
  }, []);
  return <AdminDataProvider data-id="element-1" data-mp="3mlatmwc87vop">
      <BrowserRouter data-id="element-2" data-mp="3mkhmvvd9p66k">
        <Routes data-id="element-3" data-mp="3mjzpgvevclx2">
          <Route path="/" element={<PublicSite data-id="element-5" data-mp="3rcj6k2crlz6m" />} data-id="element-4" data-mp="3mjgczu7zmpqf" />
          <Route path="/admin/login" element={<AdminLogin data-id="element-7" data-mp="3rd189ei755lx" />} data-id="element-6" data-mp="3rdapodp6e4g0" />
          <Route path="/admin" element={<RequireAdmin data-id="element-9" data-mp="56l3b4umzkw">
                <AdminShell data-id="element-10" data-mp="2zl3cjn8vpa6d" />
              </RequireAdmin>} data-id="element-8" data-mp="5yhgo69t1c8">
            <Route index element={<Overview data-id="element-12" data-mp="33mf25srr5vek" />} data-id="element-11" data-mp="2zng1ikd20ksx" />
            <Route path="sager" element={<Cases data-id="element-14" data-mp="33mym1f0yqtv8" />} data-id="element-13" data-mp="33nq5xsl7735o" />
            <Route path="sager/ny" element={<CaseNew data-id="element-16" data-mp="38l8eviz7tido" />} data-id="element-15" data-mp="33oi0r16z0wuw" />
            <Route path="sager/:caseId" element={<CaseDetail data-id="element-18" data-mp="38o4gpie6or7e" />} data-id="element-17" data-mp="38l06o4e1f18t" />
            <Route path="kunder" element={<Customers data-id="element-20" data-mp="3dlnru9fl4nv4" />} data-id="element-19" data-mp="3dle3eqa6uorj" />
            <Route path="kunder/:customerId" element={<CustomerDetail data-id="element-22" data-mp="nw2bq4xkjoqk" />} data-id="element-21" data-mp="3dirwmsv4gdad" />
            <Route path="indstillinger" element={<Settings data-id="element-24" data-mp="nxx0jubyo0zx" />} data-id="element-23" data-mp="nv0zhx4tgw79" />
          </Route>
          <Route path="*" element={<Navigate to="/" replace data-id="element-26" data-mp="st2k4mhw53ku" />} data-id="element-25" data-mp="stko65asom3b" />
        </Routes>
      </BrowserRouter>
    </AdminDataProvider>;
}